<template>
	<span :class="['svg-container', `contain-${contain}`]">{{src}}</span>
</template>

<script>
const cache = new Map();
export default {
	props: {
		src: {
			type: String,
			required: true,
		},
		contain: {
			type: String,
			default: "width",
			validate: (value) => ["height", "width", "none"].includes(value),
		},
	},
	mounted() {
		this.getSVG();
	},
	updated() {
		this.getSVG();
	},
	methods: {
		getSVG() {
			if ("assets" in this.$store.state && "loader" in this.$store.state.assets) {
				const preloadedSVG = this.$store.state.assets.loader.getResult(this.src, true);
				if (preloadedSVG) {
					this.insertSVG(preloadedSVG);
				} else {
					this.loadSVG();
				}
			} else {
				this.loadSVG();
			}
		},
		// This is the only place we use the fetch API. This call
		// will only be made if for some reason we fail to preload an SVG and then try
		// to inline it. That _should_ never happen.  Regardless this method could be rewritten
		// to use vue-resource in order to remove the dependency on the fetch API.
		async loadSVG() {
			if (!cache.has(this.src)) {
				try {
					cache.set(this.src, fetch(this.src).then((r) => r.text()));
				} catch (e) {
					cache.delete(this.src);
				}
			}

			if (cache.has(this.src)) {
				const svg = await cache.get(this.src);
				this.insertSVG(svg);
			}
		},
		insertSVG(svgXML) {
			this.$el.innerHTML = svgXML;
			const svg = this.$el.querySelector("svg");

			if (svg) {
				svg.classList.add("vector-svg");
			}
		},
	},
};
</script>

<style lang="scss">
	.svg-container {
		display: block;

		&.contain-width {
			width: 100%;
		}

		&.contain-height {
			height: 100%;
		}

		font-size: 0; // hide any unloaded svg text
	}

	svg {
		display: block;

		.contain-width & {
			width: 100%;
			height: auto;
		}

		.contain-height & {
			width: auto;
			height: 100%;
		}
	}

	.svg-container svg:not(:root) {
		overflow: visible;
	}

	.svg-bg svg {
		height: 100%;
	}
</style>
